
import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Paths } from "paths";

import Home from "pages/home";
import NotFound from "pages/404";
import ServerError from "pages/500";
import ReactGA from "react-ga4";
import AboutPage from 'pages/about';

import Signin from 'pages/signin';
import Signup from 'pages/signup';
import Account from 'pages/account';
import Settings from 'pages/settings';
import Billing from 'pages/billing';
import VerifyEmail from 'pages/verify_email';
import Notifications from 'pages/notifications';
import Pricing from 'pages/pricing';
import Terms from 'pages/terms';
import Privacy from 'pages/privacy';
import Goodbye from 'pages/goodbye';
import Blog from 'pages/blog';
import BlogPost from 'pages/blog_post';
import Workers from 'pages/workers';
import Chat from 'pages/chat';
import ApiKeys from 'pages/api_keys';
import Deploy from 'pages/deploy';
import Worker from 'pages/worker';
import AddWorker from 'pages/add_worker';
import DataIndexes from 'pages/data_indexes';
import CreateDataIndex from 'pages/create_data_index';
import DataIndex from 'pages/data_index';
import ChatDataIndex from 'pages/chat_data_index';

const PageSwitch = () => {

  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search});
  }, [location]);

  return (
    <Routes>
      <Route exact path={Paths.NotFound.path} element={<NotFound/>} />
      <Route exact path={Paths.ServerError.path} element={<ServerError/>} />

      <Route exact path={Paths.Home.path} element={<Home/>} />
      <Route exact path={Paths.About.path} element={<AboutPage/>} />
      <Route exact path={Paths.Terms.path} element={<Terms/>} />
      <Route exact path={Paths.Privacy.path} element={<Privacy/>} />

      <Route exact path={Paths.Signin.path} element={<Signin/>} />
      <Route exact path={Paths.Signup.path} element={<Signup/>} />
      <Route exact path={Paths.VerifyEmail.path} element={<VerifyEmail/>} />

      <Route exact path={Paths.Account.path} element={<Account/>} />
      <Route exact path={Paths.Settings.path} element={<Settings/>} />
      <Route exact path={Paths.Billing.path} element={<Billing/>} />
      <Route exact path={Paths.Pricing.path} element={<Pricing/>} />
      <Route exact path={Paths.Notifications.path} element={<Notifications/>} />

      <Route exact path={Paths.Workers.path} element={<Workers/>} />
      <Route exact path={Paths.AddWorker.path} element={<AddWorker/>} />
      <Route exact path={Paths.Chat.path} element={<Chat/>} />
      <Route exact path={Paths.ApiKeys.path} element={<ApiKeys/>} />

      <Route exact path={Paths.Goodbye.path} element={<Goodbye/>} />
      <Route exact path={Paths.Blog.path} element={<Blog/>} />
      <Route exact path={Paths.Deploy.path} element={<Deploy/>} />

      <Route exact path={Paths.DataIndexes.path} element={<DataIndexes/>} />
      <Route exact path={Paths.CreateDataIndex.path} element={<CreateDataIndex/>} />
      <Route exact path={Paths.ChatDataIndex.path} element={<ChatDataIndex/>} />

      <Route path={Paths.DataIndex.path}>
        <Route path=":dataIndexId" element={<DataIndex/>} />
      </Route>

      <Route path={Paths.Worker.path}>
        <Route path=":workerId" element={<Worker/>} />
      </Route>

      <Route path={Paths.BlogPosts.path}>
        <Route path=":postId" element={<BlogPost/>} />
      </Route>
      <Route path="*" element={<Navigate to="/404" replace />}/>
    </Routes>
  );

}

export default PageSwitch;